// import { createSelector } from 'reselect';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import profile, * as fromProfile from '../Features/Profile/store/profile.reducer';
import ecommerce, * as fromEcommerce from './ecommerce.reducer';
import catalog, * as fromCatalog from './catalog.reducer';
import datastatic, * as fromDatastatic from './datastatic.reducer';

const appReducer = persistCombineReducers(
  {
    key: 'primary',
    storage,
    whitelist: ['profile', 'ecommerce'],
  },
  {
    profile,
    ecommerce,
    catalog,
    datastatic,
  },
);

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;

// Profile reducer
export const getProfile = state => fromProfile.getProfile(state.profile);
export const getToken = state => fromProfile.getToken(state.profile);
export const getRefreshToken = state =>
  fromProfile.getRefreshToken(state.profile);
export const getNewsletter = state => fromProfile.getNewsletter(state.profile);
export const getLoginLoading = state =>
  fromProfile.getLoginLoading(state.profile);

// Ecommerce reducer

export const getActiveProduct = state =>
  fromEcommerce.getActiveProduct(state.ecommerce);
export const getWishlist = state => fromEcommerce.getWishlist(state.ecommerce);
export const getCart = state => fromEcommerce.getCart(state.ecommerce);
export const getCartLength = state =>
  fromEcommerce.getCartLength(state.ecommerce);

// Catalog reducer

export const getCatalog = state => fromCatalog.getCatalog(state.catalog);

// Datastatic reducer

export const getDatastatic = state =>
  fromDatastatic.getDatastatic(state.datastatic);
